/**
 * A deploy replaces every hashed chunk, so a tab left open across one asks the origin for files it
 * no longer serves. That failure reaches a screen already on display, because the lazy boundaries
 * this app uses load on interaction rather than at startup, and `React.lazy` stores the rejection
 * and rethrows it on every later render, so the screen cannot recover without a reload.
 *
 * Vite raises `vite:preloadError` for exactly this. Reloading fetches the current manifest and puts
 * the user back on the same URL.
 */
const LAST_RELOAD_KEY = 'chunk-reload-at';

// A second failure within the window is not a stale deploy, and reloading again would spin.
const COOLDOWN_MS = 10_000;

window.addEventListener('vite:preloadError', (event) => {
  let lastReload = 0;

  try {
    lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0);
  } catch {
    // Storage is unavailable in a locked-down browser, which leaves the error to the boundary.
    return;
  }

  if (Date.now() - lastReload < COOLDOWN_MS) return;

  sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});
